import { OperaCredentialsFormData } from "./pmsSchemas";

// A failed OPERA test-connection may answer with
// "…OPERA is not configured for hotel <id>: missing appKey, extSystemCode".
// The listed names map 1:1 to advancedConfig keys (and therefore to form
// fields), except the aliases below: hotelId (Property Code), gatewayUrl
// (Gateway URL) and clientSecret, which map to the top-level fields.
const FIELD_ALIASES: Record<string, keyof OperaCredentialsFormData> = {
  gatewayUrl: "baseUrl",
  hotelId: "pmsHotelId",
  clientSecret: "clientToken",
};

const OPERA_FORM_FIELDS = new Set<string>([
  "baseUrl",
  "pmsHotelId",
  "clientToken",
  "grantType",
  "appKey",
  "clientId",
  "enterpriseId",
  "scope",
  "username",
  "password",
  "extSystemCode",
  "transport",
  "chainCode",
  "wssUrl",
  "cashierId",
]);

const MISSING_MARKER = "missing ";

export const parseMissingOperaFields = (
  message: string,
): (keyof OperaCredentialsFormData)[] => {
  const markerIndex = message.toLowerCase().lastIndexOf(MISSING_MARKER);
  if (markerIndex === -1) return [];

  return message
    .slice(markerIndex + MISSING_MARKER.length)
    .split(",")
    .map((field) => {
      const name = field.trim();
      return FIELD_ALIASES[name] ?? name;
    })
    .filter((field): field is keyof OperaCredentialsFormData =>
      OPERA_FORM_FIELDS.has(field),
    );
};
